import { Row, Typography, Col, Space, Avatar  } from "antd";
import React from 'react';
import  { useLocation } from "react-router-dom";
import axios from 'axios';
import { ARCHIVE_API_ENDPOINT } from 'src/common/constants';
import { notification } from "antd";
import { PageHeader } from "antd";
import { getAvatar, phoneMask } from  'src/common/utils';
import { ChatWindow } from  'src/components/conversation-window/chat-window';
import dayjs from "dayjs";
function HistoryDisplay(props) {
    let { Text } = Typography
    let { search } = useLocation();
    const [history, setHistory] = React.useState();
    const [userMap, setUserMap] = React.useState({});

    let q = new URLSearchParams(search).get("t")
    const displayAvatar = (history) => {
        if(history)
            return getAvatar(history.contact?.profile_picture_url, history.channel_type)
    }
    const showMaskedPhone = (history) => {
        if(history){
            if(history.channel_type === 'sms')
                return phoneMask(history.contact?.name)
            if(history.channel_type === 'wa' && history.contact?.name === history.contact?.address )
                return phoneMask(history.contact?.name)
            return history.contact?.name
        }
    }
    const loadHistory = async () => {
        try{
            let h = await axios.request({
                url: `${ARCHIVE_API_ENDPOINT}/api/v1/permalink/history?token=${q}`
            })
            if(h.data.user){
                let m = {}
                m[h.data.user.id] = h.data.user
                setUserMap(m)
            }
            setHistory(h.data)
            console.log(h.data)
        }catch(ex){
            if(ex.isAxiosError){
                if(ex.response){
                    notification.error({
                        message: "Erro!",
                        description: ex.response?.data?.message || "Não foi possível carregar o histórico. Esse link já não é mais válido."
                    })
                }
            }else{
                notification.error({
                    message: "Erro!",
                    description: "Não foi possível carregar o histórico. Esse link já não é mais válido."
                })
            }
        }
    }
    React.useEffect(()=>{
        loadHistory()
    },[])
    
    return (
        <Row wrap={false}>
            <Col xs={{span: 24}} sm={{span: 14}} md={{span: 24}} lg={{span: 24}} xl={{span: 24}} >
                <PageHeader
                    avatar={{ src: displayAvatar(history) }}
                    ghost={false}
                    className="contact-header"
                    title={showMaskedPhone(history)}
                >
                </PageHeader>
                <Row style={{fontSize: 16, marginLeft: 24}}>
                <Col xs={{span: 24}} sm={{span: 24}} md={{span: 12}} lg={{span: 12}} xl={{span: 12}}>
                <Space direction="vertical" style={{marginLeft: '10px'}}>
                    <Row>
                        <Text strong>Protocolo: </Text> 
                        <Text style={{marginLeft: '5px'}} copyable={{tooltips: ['Copiar protocolo', 'Protocolo copiado!'] }} >{history?.protocol}</Text>
                    </Row>
                    <Row wrap={false}>
                        <Text strong>Dados do Contato: </Text> 
                        <Text ellipsis={true} style={{marginLeft: '5px'}}> <Avatar size="small" src={getAvatar(null, history?.contact?.type)}/> {history?.contact ? phoneMask(history.contact.address) : '-'} </Text>
                    </Row>
                    <Row>
                        <Text strong>Data Início do Contato: </Text> <Text ellipsis={true} style={{marginLeft: '5px'}}>{history?.created_at ? dayjs(history?.created_at).format("DD/MM/YYYY HH:mm") : '-'}</Text>
                    </Row>
                    <Row>
                        <Text strong>Operador Responsável: </Text>
                        <Text ellipsis={true} style={{marginLeft: '5px'}}>{history?.user ? history.user.name : '-'}</Text>
                    </Row>
                </Space>
                </Col>
                <Col xs={{span: 24}} sm={{span: 24}} md={{span: 12}} lg={{span: 12}} xl={{span: 12}}>
                <Space direction="vertical" style={{marginLeft: '10px'}}>
                    <Row>
                        <Text strong>Organização / Filial: </Text> 
                        <Text ellipsis={true} style={{marginLeft: '5px'}}>{history?.organization?.name} / {history?.company?.name}</Text>
                    </Row>
                    <Row>
                        <Text strong>Departamento / Canal: </Text> 
                        <Text ellipsis={true} style={{marginLeft: '5px'}}>{history?.department ? history.department.name : '-'} / </Text>
                        <Text ellipsis={true} style={{marginLeft: '5px'}} >{history?.channel ? history.channel.name : '-'}</Text>
                    </Row>
                   
                    <Row>
                        <Text strong>Encerrado em: </Text> 
                        <Text ellipsis={true} style={{marginLeft: '5px'}}>{history?.closed_at ? dayjs(history?.closed_at).format("DD/MM/YYYY HH:mm") : '-'}</Text>
                    </Row>
                    <Row>
                        <Text strong>Encerrado por: </Text> 
                        <Text ellipsis={true} style={{marginLeft: '5px'}}>{history?.closed_by_user ? history.closed_by_user.name : '-'}</Text>
                    </Row>
                </Space>
                </Col>
                </Row>
                
                <ChatWindow
                    messages={history?.messages}
                    contact={history?.contact}
                    users={userMap}
                    className="messaging-container attendance-list"
                />
            </Col>
        </Row>
    );
}
export default HistoryDisplay